import { gql } from "@apollo/client";

export const customerLogin = gql`
  mutation customerLogin($password: String!, $phone: String!) {
    customerLogin(password: $password, phone: $phone) {
      message
      statusCode
      success
      data {
        accessToken
        expiredAt
        type
      }
    }
  }
`;
